// extracted by mini-css-extract-plugin
module.exports = {"lastUpdated":"Project-styles--last-updated--1i4i5","projectDescription":"Project-styles--project-description--1QSxV","projectName":"Project-styles--project-name--3hCp5"};